import {
  HStack,
  Stack,
  Skeleton,
  SkeletonText,
  Spacer,
  StackDivider,
  UnorderedList
} from '@chakra-ui/react';
import { getNumberArray } from '@util/helpers';

export default function MeetingPageSkeleton() {
  return (
    <Stack
      gap={11}
      p={11}
    >
      <Skeleton
        w='20%'
        h={4}
      />
      <Stack
        divider={<StackDivider style={{ margin: 0 }} />}
        layerStyle='section-card'
        p={0}
      >
        <Stack
          flex={1}
          gap={0.5}
          p={6}
        >
          <Skeleton
            w='50%'
            h={4}
            mb={2}
          />
          <Skeleton
            w='70%'
            h={4}
          />
        </Stack>
        <HStack p={6}>
          <Skeleton
            w='20%'
            h={8}
          />
          <Spacer />
          <Skeleton
            w='7%'
            h={8}
          />
          <Skeleton
            w='7%'
            h={8}
          />
          <Skeleton
            w='3%'
            h={8}
          />
        </HStack>
      </Stack>
      <Stack
        layerStyle='section-card'
        p={8}
        gap={8}
      >
        <Skeleton
          w='90%'
          h={8}
        />
        {getNumberArray(3).map((index) => (
          <Stack
            key={index}
            bgColor='surface.containerLow'
            border='reskin'
            borderRadius='lg'
            p={3}
            gap={3}
          >
            <HStack>
              <Skeleton
                w='2%'
                h={5}
              />
              <Skeleton
                w='40%'
                h={5}
              />
            </HStack>
            <UnorderedList
              color='surface.onSurfaceVariant'
              fontWeight={500}
            >
              <SkeletonText
                w='85%'
                noOfLines={2}
                skeletonHeight='8px'
                mb={7}
              />
              <SkeletonText
                w='95%'
                noOfLines={2}
                skeletonHeight='8px'
                mb={7}
              />
              <SkeletonText
                w='55%'
                noOfLines={1}
                skeletonHeight='8px'
                mb={7}
              />
            </UnorderedList>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
